<template>
  <div class="min-w-0 w-full">
    <div class="display-1 d-flex">
      <span>Luo sopimuspohja</span>
      <v-spacer></v-spacer>
      <v-btn v-if="isAuthorized('contract', 'create')" color="info" @click="goBack()">
        Takaisin
      </v-btn>
    </div>

    <v-card class="mt-2">
      <v-container class="container-wrapper">
        <contract-model-form
          :model="model"
          save-btn-text="Luo"
          @sendcontractmodeldata="createNewmodel($event)"
        ></contract-model-form>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import mixins from "../../mixins/mixins";
import axiosMethods from "../../mixins/axios";
import ContractModelForm from "../../components/ContractModels/ContractModelForm";

export default {
  title: "Luo vuokrasopimuspohja",

  components: {
    ContractModelForm,
  },

  mixins: [mixins],

  data() {
    return {
      model: {},
    };
  },

  methods: {
    async createNewmodel(data) {
      try {
        await axiosMethods.post("/api/v1/contract-model/create", data);
        this.showPopup("Uusi sopimuspohja luotu", "success");
      } catch (err) {
        this.showPopup(err, "error");
      }
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .container-wrapper {
    margin: 0;
    padding: 0;
  }
}
</style>
